/**
 * Created by andresvasquez on 12/14/17.
 */
import {Injectable} from '@angular/core';
import {Platform} from 'ionic-angular';
import {SimulatorConfiguration} from "../models/simulator.config";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import {TagReadResponse} from "../models/reader-model/tagReadResponse";
import {TagSimulator} from "../models/TagSimulator";
import {READER_MODE_GEIGER, READER_MODE_INVENTORY} from "../app/app.constants";
import {VizixService} from './vizix.service';

@Injectable()
export class SimulatorService {

  private tag = '[SIMULATOR_SERVICE]';

  public isSimulatorEnabled: boolean = false;
  private isFileLoaded: boolean = false;
  private isCanceled: boolean = false;

  private simulatorConfig: SimulatorConfiguration;
  private cursor: number;

  private rfids: TagSimulator[];
  private timer;
  private inventoryTimer;

  private tagObservable: Observable<TagReadResponse>;
  private tagObserver: Observer<TagReadResponse>;
  private counterSession: number;

  private mode: number;

  constructor(public http: HttpClient, private platform: Platform, private _vizixService: VizixService) {
  }

  public init() {
    console.log(this.tag, "SimulatorConfiguration", "Init");
    this.tagObservable = Observable.create(observer => {
      this.tagObserver = observer;
    });

    /*let simulator = new SimulatorConfiguration();
     simulator.Enabled = true;
     simulator.Interval = 5;
     simulator.InitialDelay = 500;
     simulator.IsFromJsonFile = true;
     simulator.JsonFilePath = "/assets/json/epcs.json";
     simulator.Quantity = 1000;
     this.config(simulator);*/
  }

  public config(config: SimulatorConfiguration) {
    this.cursor = 0;

    this.simulatorConfig = config;
    this.isSimulatorEnabled = config.Enabled.value;

    if (this.isSimulatorEnabled) {
      if (config.IsFromJsonFile.value && config.JsonFilePath.value != "") {
        this.loadFile();
      } else {
        this.isFileLoaded = false;
        //Init cursor in 1
        this.cursor++;
      }
    }
  }

  public static isURL(path): boolean {
    return path.startsWith('http://') || path.startsWith('https://');
  }

  /**
   * Simulate geiger reading start function
   */
  public simulateInventoryReadings(epcList: Array<string>) {
    this.mode = READER_MODE_INVENTORY;

    let epcFilteredList: Array<string> = [];
    // We only want epcs, not upcs
    for (let epc of epcList) {
      if (epc.length == 24) {
        epcFilteredList.push(epc);
      }
    }

    if (epcFilteredList.length > 0) {
      this.inventoryTimer = setTimeout(() => {
        if (!this.isCanceled) {
          this.simulateOneInventoryRead(epcFilteredList);
        }
      }, 3000);
    } else {
      console.log(this.tag, 'EPCs were not found in the provided list, unable to simulate')
    }
  }

  public simulateReadings() {
    this.counterSession = 0;
    this.isCanceled = false;
    this.simulateReadingsWithQuantity(this.simulatorConfig.Quantity.value);
  }

  public simulateGeiger(epc: string) {
    this.counterSession = 0;
    this.isCanceled = false;
    this.simulateGeigerReadings(epc);
  }

  public simulateInventory(epcList: Array<string>) {
    this.counterSession = 0;
    this.isCanceled = false;
    this.simulateInventoryReadings(epcList);
  }

  /**
   * Simulate reading start function
   * @param quantity
   */
  public simulateReadingsWithQuantity(quantity: number) {
    //Initial delay for simulator
    if (this.simulatorConfig.InitialDelay.value > 0) {
      setTimeout(() => {
        this.simulateOneRead(quantity);
      }, this.simulatorConfig.InitialDelay.value);
    } else {
      this.simulateOneRead(quantity);
    }
  }

  /**
   * Simulate geiger reading start function
   */
  public simulateGeigerReadings(epc: string) {
    this.mode = READER_MODE_GEIGER;
    //Initial delay for simulator
    if (this.simulatorConfig.InitialDelay.value > 0) {
      setTimeout(() => {
        this.simulateOneGeigerRead(epc, 0, -99);
      }, this.simulatorConfig.InitialDelay.value);
    } else {
      this.simulateOneGeigerRead(epc, 0, -99);
    }
  }

  /**
   * Send read event
   * @param rfidTag object tag to send event
   */
  public sendReadEvent(rfidTag: TagReadResponse) {
    rfidTag.rssi = -90;
    rfidTag.rssiPercentage = 0;
    rfidTag.time = this._vizixService.vizixTime();
    this.tagObserver.next(rfidTag);
  }

  /**
   * Simulate one reader recursive
   * @param quantity: Max
   */
  public simulateOneRead(quantity: number) {
    this.timer = setTimeout(() => {
      if (!this.isCanceled) {

        if (this.isFileLoaded) {
          if (this.cursor < this.rfids.length) {
            let tag = new TagReadResponse();
            tag.value = this.rfids[this.cursor].rfid;
            tag.upc = this.rfids[this.cursor].upc;
            this.sendReadEvent(tag);
          }
        } else {
          this.sendReadEvent(this.generateTagWithPrefix());
        }

        this.counterSession++;
        this.cursor++;
        if (this.counterSession < quantity) {
          this.simulateOneRead(quantity);
        }
      }
    }, this.simulatorConfig.Interval.value);
  }

  /**
   * Simulate one reader recursive
   * @param epcList The list of all the epcs to choose from
   */
  public simulateOneInventoryRead(epcList: Array<string>) {
    // console.log(this.tag, 'Simulating one inventory read');
    this.inventoryTimer = setTimeout(() => {
      if (!this.isCanceled && this.mode == READER_MODE_INVENTORY) {
        let tag = new TagReadResponse();
        tag.value = this.selectStartGeigerFromList(epcList); // get random epc
        // console.log(this.tag, 'Simulated inventory tag', tag.value);
        this.sendReadEvent(tag);
        this.simulateOneInventoryRead(epcList);
      }
    }, this.simulatorConfig.Interval.value); // TODO: ADD DIFFERENT INTERVAL FOR ALL MODES
  }

  /**
   * Simulate one geiger reader recursive
   * @param epc: EPC to simulate geiger readings for
   * @param rssiPercentage tag proximity in %
   * @param rssi tag prximity in dB
   */
  public simulateOneGeigerRead(epc: string, rssiPercentage: number, rssi: number) {
    // console.log(this.tag, 'Simulating geiger', epc, rssiPercentage);
    this.timer = setTimeout(() => {
      if (!this.isCanceled && this.mode == READER_MODE_GEIGER) {
        let tag = new TagReadResponse();
        tag.value = epc;
        tag.upc = '';
        tag.rssiPercentage = rssiPercentage;
        // tag.rssi = rssi; // To prevent using RSSI as measurement and use percentage instead
        // console.log(this.tag, 'Simulated geiger tag', tag.value);
        this.sendGeigerEvent(tag);

        this.simulateOneGeigerRead(epc,
          this.getNewRSSIPercentage(rssiPercentage),
          this.getNewRSSI(rssi));
      }
    }, this.simulatorConfig.RssiChangeInterval.value);
  }

  getNewRSSIPercentage(oldRSSIPercentage: number): number {
    return this.simulatorConfig.IsRssiIncremental.value ?
      (oldRSSIPercentage + 1) > 100 ? 100 : oldRSSIPercentage + 1 :
      Math.floor(Math.random() * 101); // Random between 0 - 100
  }

  getNewRSSI(oldRSSI: number): number {
    return (oldRSSI + 1) > 0 ? 0 : oldRSSI + 1;
  }

  /**
   * Generate tag with prefix
   * @returns {string} Rfid tag simulated
   */
  public generateTagWithPrefix(): TagReadResponse {
    let rfidTag: string = "";
    if (this.simulatorConfig.Prefix != null) {
      rfidTag += this.simulatorConfig.Prefix.value;
    }

    let lastPath: string = "" + this.cursor;

    let zerosToFill: number = 24 - (rfidTag.length + lastPath.length);
    if (zerosToFill > 0) {
      for (let i = 0; i < zerosToFill; i++) {
        rfidTag += "0";
      }
    }

    //Add last path
    rfidTag += lastPath;

    //Add as Tag object
    let tag = new TagReadResponse();
    tag.value = rfidTag;
    tag.upc = "";
    return tag;
  }

  selectStartGeigerFromList(epcList: Array<string>): string {
    if (epcList.length > 0) {
      let length = epcList.length;
      let randomIndex = Math.floor(Math.random() * length);
      return epcList[randomIndex];
    } else {
      return null;
    }
  }

  /**
   * Send read event
   * @param rfidTag object tag to send event
   */
  public sendGeigerEvent(rfidTag: TagReadResponse) {
    rfidTag.time = this._vizixService.vizixTime();
    this.tagObserver.next(rfidTag);
  }

  private loadFile() {
    console.log(this.tag, "SimulatorConfiguration Load from file", this.simulatorConfig.JsonFilePath.value);

    if (this.platform.is('cordova') && this.platform.is('android')) {
      if (!SimulatorService.isURL(this.simulatorConfig.JsonFilePath.value)) {
        this.simulatorConfig.JsonFilePath.value = "/android_asset/www" + this.simulatorConfig.JsonFilePath.value;
      }
    }

    this.http.get(this.simulatorConfig.JsonFilePath.value)
      .subscribe(
        (data: TagSimulator[]) => {
          this.rfids = data;
          this.isFileLoaded = true;
          console.log(this.tag, this.rfids);
        },
        err => {
          console.log(this.tag, "Error loading file: ", this.simulatorConfig.JsonFilePath.value, err);

          //Init cursor in 1
          this.cursor++;
        });
  }

  /**
   * Stop simulator
   */
  public stopSimulator() {
    this.isCanceled = true;
    console.log(this.tag, 'Stopping simulator');
    clearTimeout(this.timer);
    clearTimeout(this.inventoryTimer);
  }

  /**
   * Return observable for subscribe to simulator
   * @returns {Observable<any>}
   * @public
   */
  public getTagObservable() {
    return this.tagObservable;
  }

  public clearCursor() {
    this.cursor = 0;
  }
}



// WEBPACK FOOTER //
// ./src/providers/simulator.service.ts